import React from 'react';
import { LoadingIndicator, FLink } from '@components';
import { useSelector } from 'react-redux';
import {
  differenceInCalendarMonths,
  differenceInCalendarYears,
  parse,
} from 'date-fns';
import {
  CALCULADORA_EXAURIMENTO,
  EMISSAO_BOLETO_VOLUNTARIO,
  PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
  SAIBA_MAIS_SAUDE_FINANCEIRA,
} from '../../../utils/paths';
import './styles.css';

export const SaudeFinanceiraCard = () => {
  const saudeFinanceiraState = useSelector(
    (state) => state.plan?.saudeFinanceira
  );
  const saudeFinanceira = saudeFinanceiraState?.data || {};
  const { aporte: showAporte, alterar_recebimento: showRecebimento } =
    useSelector((state) => state.configs.telasDisponiveis.data);

  const tempoExaurimento = () => {
    const dataCalculo = parse(
      `01/${saudeFinanceira?.exaurimento?.dataExaurimento}`,
      'dd/MM/yyyy',
      new Date()
    );
    const anos = differenceInCalendarYears(new Date(dataCalculo), new Date());
    const meses = differenceInCalendarMonths(new Date(dataCalculo), new Date());
    if (!anos && !meses) {
      return '.';
    }
    return anos
      ? `, ou seja, daqui ${anos} anos.`
      : `, ou seja, daqui ${meses} meses.`;
  };

  return (
    <div className="card">
      {!saudeFinanceiraState?.loading ? (
        <div>
          {saudeFinanceira?.exaurimento?.msgConsistencia === '' ? (
            <>
              <div className="card-body">
                <h1 className="ts-20 fw-bold mb-2">
                  Saúde financeira do seu saldo
                </h1>
                <p className="ts-14 text-muted mb-4">
                  Acompanhe a saúde financeira do seu saldo e gerencie seus
                  recursos de forma eficiente.
                </p>

                {/* <div className="HealthWrapper">
                  <div className="ActualSign">
                    <p className="SignText">Farol atual:</p>
                  </div>
                  {saudeFinanceira?.farol === 'Verde' && (
                    <div className="colorSignGreen">
                      <p className="SignText">Verde</p>
                    </div>
                  )}
                  {saudeFinanceira?.farol === 'Laranja' && (
                    <div className="colorSignOrange">
                      <p className="SignText">Laranja</p>
                    </div>
                  )}
                  {saudeFinanceira?.farol === 'Vermelho' && (
                    <div className="colorSignRed">
                      <p className="SignText">Vermelho</p>
                    </div>
                  )}
                </div> */}
                {saudeFinanceira?.exaurimento?.dataPercentualMaximo ? (
                  <p className="ts-14 text-muted mb-32">
                    Atualmente sua retirada mensal é de{' '}
                    <b>{saudeFinanceira?.percentualRetirada}%</b>. A perda do
                    poder aquisitivo deve ocorrer em{' '}
                    {saudeFinanceira?.exaurimento?.dataPercentualMaximo} e o{' '}
                    <b>
                      esgotamento do seu benefício deve acontecer em{' '}
                      {
                        saudeFinanceira?.exaurimento?.dataExaurimento?.split(
                          '/'
                        )[1]
                      }
                    </b>
                    , ou seja, daqui{' '}
                    {saudeFinanceira?.exaurimento?.tempoExaurimento} anos.
                  </p>
                ) : (
                  <p className="ts-14 text-muted mb-32">
                    Atualmente sua retirada mensal é de{' '}
                    <b>{saudeFinanceira?.percentualRetirada}%</b>. O{' '}
                    <b>
                      esgotamento do seu benefício deve acontecer em{' '}
                      {
                        saudeFinanceira?.exaurimento?.dataExaurimento?.split(
                          '/'
                        )[1]
                      }
                    </b>
                    {tempoExaurimento()}
                  </p>
                )}

                <p className="ts-14 text-muted">
                  Descubra abaixo o que você pode fazer:
                </p>
              </div>
              <div className="card-footer">
                {showRecebimento && (
                  <>
                    <hr className="mb-4" />
                    <FLink to={CALCULADORA_EXAURIMENTO} icon>
                      Simulador de evolução de saldo
                    </FLink>
                    <hr className="mb-4 mt-4" />
                    <FLink to={PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH} icon>
                      Reduza sua retirada mensal
                    </FLink>
                  </>
                )}
                {showAporte && (
                  <>
                    <hr className="mb-4 mt-4" />
                    <FLink to={EMISSAO_BOLETO_VOLUNTARIO} icon>
                      Realize um novo aporte
                    </FLink>
                  </>
                )}
                <hr className="mb-4 mt-4" />
                <FLink to={SAIBA_MAIS_SAUDE_FINANCEIRA} icon>
                  Saiba mais
                </FLink>
              </div>
            </>
          ) : (
            <div className="card-body">
              <h1 className="ts-20 fw-bold mb-2">
                Saúde financeira do seu saldo
              </h1>
              <p className="ts-14 text-muted mb-4">
                Infelizmente não foi possível carregar as informações de saúde
                financeira da sua conta. Entre em contato pelo 0800 090 9090 ou
                atendimento@forluz.org.br e solicite sua simulação.
              </p>
            </div>
          )}
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};
